import type { TOC } from '@ember/component/template-only';
import {
  PrismButton,
  PrismCard,
  PrismIllustration,
  PrismLoadingBar,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralPageHeader from 'lumen/components/general/page/header';
import GeneralPageMain from 'lumen/components/general/page/main';
import type HotelReservationManagerController from 'lumen/controllers/hotel/reservation-manager';

interface HotelReservationManagerSignature {
  Args: {
    controller: HotelReservationManagerController;
    model: unknown;
  };
}

<template>
  <GeneralPageHeader>
    <div class="content-wrapper"></div>
  </GeneralPageHeader>

  <GeneralPageMain>
    <div class="content-wrapper main-content h-full">
      <PrismCard class="relative h-full w-full">
        <:content>
          {{#if @controller.isManualRedirectFlow}}
            <div
              class="flex h-full w-full flex-col items-center justify-center"
            >
              <PrismIllustration @name="100x100_tangled" @size="medium" />
              <PrismButton
                @label={{t "reservation_manager.redirect.button.label"}}
                @onClick={{@controller.model.handleRedirect}}
              />
            </div>
          {{else}}
            <PrismLoadingBar />
            <div
              class="flex h-full w-full flex-col items-center justify-center"
            >
              <PrismIllustration @name="100x100_progress" @size="medium" />
              <h3>{{t "general.loading"}}</h3>
            </div>
          {{/if}}
        </:content>
      </PrismCard>
    </div>
  </GeneralPageMain>
</template> satisfies TOC<HotelReservationManagerSignature>;
